import ParsedDecoratorChildren from "../components/ParsedDecoratorChildren";
import { REGEX_IU } from "../regex";
import { jsx as _jsx } from "react/jsx-runtime";
var ItalicUnderline = function ItalicUnderline(_ref) {
  var offsetKey = _ref.offsetKey,
    decoratedText = _ref.decoratedText,
    isDark = _ref.isDark;
  var text = decoratedText.match(REGEX_IU) ? decoratedText.substring(2, decoratedText.length - 2) : decoratedText;
  return /*#__PURE__*/_jsx("i", {
    className: "italic underline",
    "data-offset-key": offsetKey,
    children: /*#__PURE__*/_jsx(ParsedDecoratorChildren, {
      text: text,
      isDark: isDark
    })
  });
};
export default ItalicUnderline;